document.addEventListener('DOMContentLoaded', function () {
    var coreStorySlider = new MinimogLibs.Swiper('.core-story-slider', {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: false,
      autoplay: false,
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      slidesPerGroup: 1,
      breakpoints: {
        1025: { slidesPerView: 3 },
        768: { slidesPerView: 2 },
        0: { slidesPerView: 1.2 }
      },
    });
  });
